import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Grid,
  Option,
  Select,
  Stack,
} from "@mui/joy";
import { Fragment, memo, useCallback } from "react";
import {
  AdvertiserAudienceGeneratorHeader,
  AdvertiserAudienceGeneratorStep,
  AudienceGeneratorStepActionsWrapper,
  AudienceGeneratorStepSectionDescription,
  AudienceGeneratorStepSectionTitle,
  useAdvertiserAudienceGenerator,
} from "features/mediaDataRoom/containers/AdvertiserAudienceGenerator";
import { useDataRoomSnackbar } from "hooks";
import { useRemarketingAdvertiserAudienceGenerator } from "../../contexts/RemarketingAdvertiserAudienceGeneratorContext";

const RemarketingAdvertiserAudienceGeneratorConfigurationStep = memo(() => {
  const { handleBackStep, handleNextStep, isFirstStep, cancelGeneration } =
    useAdvertiserAudienceGenerator();
  const { enqueueSnackbar } = useDataRoomSnackbar();
  const { selectedSeedAudience, setSelectedSeedAudience, seedAudiences } =
    useRemarketingAdvertiserAudienceGenerator();
  const shouldCancelGenerationOnBack = isFirstStep(
    AdvertiserAudienceGeneratorStep.CONFIGURATION
  );
  const handleNextStepClick = useCallback(() => {
    if (!selectedSeedAudience) {
      enqueueSnackbar("Please select seed audience", {
        persist: true,
        variant: "info",
      });
      return;
    }
    handleNextStep();
  }, [enqueueSnackbar, handleNextStep, selectedSeedAudience]);
  return (
    <Fragment>
      <Grid container={true} sx={{ height: "100%" }}>
        <Grid xs={7}>
          <Box mb={3}>
            <AdvertiserAudienceGeneratorHeader />
          </Box>
          <Stack direction="column" spacing={2}>
            <Box>
              <AudienceGeneratorStepSectionTitle>
                1. Remarketing audience setup
              </AudienceGeneratorStepSectionTitle>
              <AudienceGeneratorStepSectionDescription>
                Choose the audience that will be used to seed your remarketing
                audience.
              </AudienceGeneratorStepSectionDescription>
            </Box>
            <FormControl>
              <FormLabel>Seed audience</FormLabel>
              <Select
                onChange={(_, value) => {
                  const selectedSeedAudience = seedAudiences.find(
                    ({ id }) => id === value
                  );
                  setSelectedSeedAudience(selectedSeedAudience!);
                }}
                placeholder="Select an audience"
                value={selectedSeedAudience?.id || ""}
              >
                {seedAudiences.map(({ id, name }) => (
                  <Option key={id} value={id}>
                    {name}
                  </Option>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      </Grid>
      <AudienceGeneratorStepActionsWrapper>
        <Button
          onClick={
            shouldCancelGenerationOnBack ? cancelGeneration : handleBackStep
          }
          sx={{ mr: 1 }}
        >
          {shouldCancelGenerationOnBack ? "Cancel" : "Back"}
        </Button>
        <Button color="primary" onClick={handleNextStepClick} variant="solid">
          Continue
        </Button>
      </AudienceGeneratorStepActionsWrapper>
    </Fragment>
  );
});

RemarketingAdvertiserAudienceGeneratorConfigurationStep.displayName =
  "RemarketingAdvertiserAudienceGeneratorConfigurationStep";

export default RemarketingAdvertiserAudienceGeneratorConfigurationStep;
